import { Component } from './component';

export interface LabelProps {
  text: string;
  for?: string;
}

export class Label extends Component {
  public el: HTMLLabelElement;

  constructor(props: LabelProps) {
    super();
    this.el = document.createElement('label');
    this.el.appendChild(document.createTextNode(props.text));

    if (props.for) {
      this.el.setAttribute('for', props.for);
    }
  }
}
